<template>
    <section class="member-content">
        <div class="item" @click="gotoLink('/vip/apply')">
            <img src="../../assets/images/index-rhsq.png" alt="" />
            <p>入会申请</p>
        </div>
        <div
            class="item"
            @click="gotoLink('/exhibition/exhibitorCenter/signUp')"
        >
            <img src="../../assets/images/index-czbm.png" alt="" />
            <p>参展报名</p>
        </div>
        <div class="item">
            <div class="item-box" @click="gotoLink('/statistics')">
                <img src="../../assets/images/index-tjsjtb.png" alt="" />
                <p>统计信息</p>
        </div>
        <div class="item-box" @click="gotoLink('/technical')">
                <img src="../../assets/images/jishuduijie.png" alt="" />
                <p>技术对接平台</p>
        </div>
        </div>
        <div class="item" @click="gotoLink('/product')">
            <img src="../../assets/images/index-cpcx.png" alt="" />
            <p>产品查询</p>
        </div>
        <div class="item" @click="gotoLink('/train/technicalTraining')">
            <div class="flex-index">
                <img src="../../assets/images/index-pxbm.png" alt="" />
                <p>培训报名</p>
            </div>
        </div>
        <div class="item" @click="gotoLink('/aboutAssociation/10')">
            <div class="flex-index">
                <img src="../../assets/images/index-djyd.png" alt="" />
                <p>党建园地</p>
            </div>
        </div>
        <div class="item" @click="gotoLink('openUrl')">
            <div class="flex-index">
                <img src="../../assets/images/index-yymzz.png" alt="" />
                <p>液气密杂志</p>
            </div>
        </div>
        <div class="item" @click="gotoLink('/feedback')">
            <div class="flex-index">
                <img src="../../assets/images/index-lyfk.png" alt="" />
                <p>留言反馈</p>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    // 组件方法
    methods: {
        gotoLink(data) {
            if (data == 'openUrl') {
                window.open('http://j.chpsa.org.cn/')
            }else if(data == '/statistics'){
                console.log(data)
                // this.$message.error('敬请期待');
                this.$router.push(data);

            }else{
                this.$router.push(data);
            }
        },
    },
};
</script>
<style scoped>
.member-content {
    /* display: flex;
    justify-content: space-between;
    flex-wrap: wrap; */
    margin-top: 20px;
    position: relative;
}

.member-content .item {
    display: inline-block;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    line-height: 1;
    text-align: center;
}

/* .member-content .module1 {
    display: inline-block;
} */
.member-content .item:nth-child(1) {
    width: 110px;
    height: 97px;
    margin-right: 5px;
    background: linear-gradient(180deg, #ffd77b 0%, #f1801d 100%);
    padding-top: 20px;
    cursor: pointer;
}

.member-content .item:nth-child(1) p,
.member-content .item:nth-child(2) p {
    margin-top: 13px;
}

.member-content .item:nth-child(2) {
    width: 110px;
    height: 97px;
    margin-right: 5px;
    background: linear-gradient(180deg, #7dc1fe 0%, #3182e1 100%);
    padding-top: 20px;
    cursor: pointer;
}

.member-content .item:nth-child(3) {
    width: 225px;
    margin-right: 5px;
    margin-top: 5px;
    position: relative;
    font-size: 16px;
    color: #FFFFFF;
}

.member-content .item:nth-child(3) .item-box:nth-child(1) {
    width: 110px;
    height: 70px;
    padding-top: 9px;
    border-radius: 4px;
    background: linear-gradient(180deg, #ffc288 0%, #e45b2f 100%);
    cursor: pointer;
}
.member-content .item:nth-child(3) .item-box:nth-child(2) {
    padding-top: 9px;
    width: 110px;
    height: 70px;
    background: linear-gradient(180deg, #5CDFA3 0%, #2BB374 100%);
    border-radius: 4px;
    padding-top: 10px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
}
.member-content .item:nth-child(3) .item-box img{
    margin-bottom: 11px;
}
.member-content .item:nth-child(4) {
    position: absolute;
    top: 0;
    width: 147px;
    height: 172px;
    background: linear-gradient(180deg, #7897fc 0%, #394bee 100%);
    padding-top: 47px;
    cursor: pointer;
}
.member-content .item:nth-child(4) img {
    width: 40px;
    height: 40px;
    margin-bottom: 22px;
}


.member-content .item:nth-child(5) {
    width: 186px;
    height: 70px;
    margin-right: 5px;
    margin-top: 5px;
    background: linear-gradient(180deg, #81e3ff 0%, #1ca9d2 100%);
}

.member-content .item:nth-child(6) {
    width: 186px;
    height: 70px;
    margin-top: 5px;
    background: linear-gradient(180deg, #FF7457 0%, #DE2929 100%);
}
.member-content .item:nth-child(7) {
    width: 186px;
    height: 70px;
    margin-top: 5px;
    margin-right: 5px;
    background: linear-gradient(180deg, #DBEC7D 0%, #85C93E 100%);
}
.member-content .item:nth-child(8) {
    width: 186px;
    height: 70px;
    margin-top: 5px;
    background: linear-gradient(180deg, #9584ff 0%, #5935f0 100%);
}

.member-content .item img {
    width: 24px;
    height: 24px;
}

.flex-index {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.flex-index p {
    margin-left: 10px;
}
p {
}
</style>
